export const endpoints = {
  // auth
  ME: "/users/me",
  TOKEN: "/auth/token",

  // orders stats
  ORDERS_STAT: "/orders",
};
